/**
 * FAQ Accordion Search
 * Filters accordion items by heading + content text.
 */

function initFaqSearch() {
  const inputs = document.querySelectorAll('[data-faq-search]');

  inputs.forEach((input) => {
    if (input.dataset.initialized === 'true') return;

    const accordion = input.closest('[data-faq-accordion]');
    if (!accordion) return;

    const items = Array.from(accordion.querySelectorAll('.faq-accordion-item'));
    const emptyState = accordion.querySelector('[data-faq-search-empty]');
    let debounceTimer = null;

    const filterItems = () => {
      const query = input.value.trim().toLowerCase();
      const isSearching = query.length > 0;
      let matchCount = 0;

      accordion.classList.toggle('is-searching', isSearching);

      items.forEach((item) => {
        if (!isSearching) {
          item.classList.remove('faq-search-hidden');
          return;
        }

        const text = (item.textContent || '').toLowerCase().replace(/\s+/g, ' ').trim();
        const matches = text.includes(query);
        item.classList.toggle('faq-search-hidden', !matches);
        if (matches) matchCount += 1;
      });

      if (emptyState) {
        if (isSearching && matchCount === 0) {
          emptyState.removeAttribute('hidden');
        } else {
          emptyState.setAttribute('hidden', 'hidden');
        }
      }
    };

    input.addEventListener('input', () => {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(filterItems, 120);
    });

    input.addEventListener('search', filterItems);

    input.dataset.initialized = 'true';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFaqSearch);
} else {
  initFaqSearch();
}

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initFaqSearch);
  document.addEventListener('shopify:block:select', initFaqSearch);
}
